/**
 * Application configuration from environment variables.
 * CRITICAL: NO fallback to localhost - fail fast if not configured.
 */

interface Config {
  apiBaseUrl: string;
  wsBaseUrl: string;
}

function getRequiredEnv(key: string): string {
  const value = import.meta.env[key];

  if (!value) {
    throw new Error(
      `ERROR: Environment variable ${key} is required but not set. ` +
      `Please create a .env file with all required variables. ` +
      `See .env.example for template.`
    );
  }

  return value;
}

// Export configuration - throws error if environment not properly configured
export const config: Config = {
  apiBaseUrl: getRequiredEnv('VITE_API_BASE_URL'),
  wsBaseUrl: getRequiredEnv('VITE_WS_BASE_URL'),
};

// AI request defaults
export const AI_DEFAULTS = {
  MAX_TOKENS: 4096,
  TEMPERATURE: 0.7,
} as const;
